<template>
  <div>
    <!--    <div-->
    <!--      class="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10"-->
    <!--    >-->
    <!--      <span class="font-weight-bold font-size-3 text-dark-60">-->
    <!--        Don't have an account yet?-->
    <!--      </span>-->
    <!--      <router-link-->
    <!--        :to="{ name: 'register' }"-->
    <!--        class="font-weight-bold font-size-3 ml-2"-->
    <!--      >-->
    <!--        Sign Up!-->
    <!--      </router-link>-->
    <!--    </div>-->
    <div>
      <div class="login-form login-signin" style="display: inline-table;width: 400px;">
        <div class="text-center">
          <h3 class="font-size-h1" style="text-decoration: underline">Log In</h3>
          <p class="text-muted font-weight-semi-bold">
            <!--          Enter your email address and password-->
          </p>
        </div>
        <!--      <div class="p-3 mb-2 bg-warning text-dark text-center">-->
        <!--        ATG Portal is currently in Beta Testing Mode-->
        <!--      </div>-->
        <b-form class="form" @submit.stop.prevent="onSubmit">
          <div
              class="alert fade alert-danger"
              role="alert"
              v-bind:class="{ show: error }"
          >
            <div class="alert-text">
              {{ error }}
            </div>
          </div>
          <div
              class="alert fade alert-success"
              role="alert"
              v-bind:class="{ show: registermessage }"
          >
            <div class="alert-text">
              {{ registermessage }}
            </div>
          </div>
          <b-form-group
              id="example-input-group-1"
              label=""
              label-for="example-input-1"
          >
            <b-form-input
                id="example-input-1"
                v-model="$v.form.username.$model"
                :state="validateState('username')"
                aria-describedby="input-1-live-feedback"
                class="form-control form-control-solid h-auto py-5 px-6"
                name="example-input-1"
                placeholder="Email Address"
            ></b-form-input>
            <b-form-invalid-feedback id="input-1-live-feedback">
              Email address is required.
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group
              id="example-input-group-2"
              label=""
              label-for="example-input-2"
          >
            <b-form-input
                id="example-input-2"
                v-model="$v.form.password.$model"
                :state="validateState('password')"
                aria-describedby="input-2-live-feedback"
                class="form-control form-control-solid h-auto py-5 px-6"
                name="example-input-2"
                placeholder="Password"
                type="password"
            ></b-form-input>
            <b-form-invalid-feedback id="input-2-live-feedback">
              Password is required.
            </b-form-invalid-feedback>
          </b-form-group>

          <div
              class="form-group d-flex flex-wrap justify-content-between align-items-center"
          >
            <router-link
                :to="{ name: 'forgotpassword' }"
                class="text-dark-60 text-hover-primary my-3 mr-2"
            >
              Forgot Password
            </router-link>
            <button
                ref="kt_login_signin_submit"
                :disabled="this.isBusy || $v.$invalid"
                class="btn btn-block btn-primary font-weight-bold px-9 py-4 my-3 font-size-3"
            >
              LOG IN
            </button>
            <!--          <a class="text-dark-60 text-hover-primary my-3 mr-2" href="#" id="kt_login_forgot">-->
            <!--            Forgot Password-->
            <!--          </a>-->

          </div>
        </b-form>
      </div>

      <div style="display: inline-table; width: 450px; margin-left: 30px;">


        <div class="d-flex flex-row-fluid flex-column justify-content-between" style="text-align: center; display: flex !important;
    flex-wrap: nowrap;
    align-items: center;">

          <span>&nbsp;</span>
          <img src="/media/logos/smes-blue-welcome.png" style="width:80%;"/>

          <div class="flex-column-fluid d-flex flex-column justify-content-center" style="align-items: center">
            <h4 class="font-size-h3 mt-10 mb-5 text-default">
              Your Smart Electronic Invoicing, Bookkeeping, and Tax Filing Solution
            </h4>
<!--            <router-link :to="{ name: 'register' }" class="btn  btn-primary font-weight-bold px-9 py-4 my-3 font-size-3" style="max-width: 200px">-->
<!--              Sign Up!-->
<!--            </router-link>-->
            <a href="http://bit.ly/SMeSRegistration" target="_blank" class="btn  btn-primary font-weight-bold px-9 py-4 my-3 font-size-3" style="max-width: 200px">Sign Up!</a>
          </div>

        </div>
      </div>
    </div>


  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>

<script>
import {mapState} from "vuex";
import {LOGIN, LOGOUT} from "@/core/services/store/auth.module";
import {validationMixin} from "vuelidate";
import {email, minLength, required} from "vuelidate/lib/validators";
import ApiService from "@/view/pages/easyreceipt/api";
import Swal from "sweetalert2";

export default {
  mixins: [validationMixin],
  name: "login",
  data() {
    return {
      isBusy: false,
      form: {
        username: "",
        password: ""
      }
    };
  },
  validations: {
    form: {
      username: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(3)
      }
    }
  },
  methods: {
    validateState(name) {
      const {$dirty, $error} = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        username: null,
        password: null
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    async onSubmit() {
      this.isBusy = true;
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      const grant_type = "password";
      const username = this.$v.form.username.$model;
      const password = this.$v.form.password.$model;
      const scope = "easyreceipt";
      // clear existing errors
      this.$store.dispatch(LOGOUT);

      // set spinner to submit button
      const submitButton = this.$refs["kt_login_signin_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      try {
        await this.$store
            .dispatch(LOGIN, {
              grant_type,
              username,
              password,
              scope
            });
        this.$gtag.event("login", {method: "Web", username: username});

        const hasAcceptedLegal = await this.checkHasAcceptedLegal();
        if (hasAcceptedLegal) {
          await this.acceptedLegal(username);
        }
        else {
          await this.confirmLegalPrompts(username);
        }

        // const access = await this.checkAccess();
        // if (access && !access.IsServerlessAccountConfirmed) {
        //   this.$router.push({name: "verifyaccount", query: {username}});
        // } else if (access && access.IsServerlessAccountConfirmed) {
        //   this.$router.push({name: "dashboard"});
        // } else {
        //   //console.error(access);
        // }

      } catch (er) {
        //console.error(er);
      }
      this.isBusy = false;
      submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
      );
    },
    async checkAccess() {
      try {
        let response = await ApiService.post("business/checkaccess", {
          UserName: this.form.username
        });
        this.$gtag.event("users_checkaccess");
        return response.data;
      } catch (er) {
        return false;
      }
    },
    async checkHasAcceptedLegal() {
      try {
        let response = await ApiService.get("user/hasacceptedlegal", {
          UserName: this.form.username
        });
        this.$gtag.event("users_checkHasAcceptedLegal");
        return response.data;
      } catch (er) {
        return false;
      }
    },
    async saveAcceptedLegal(username) {
      try {
        let response = await ApiService.post("user/acceptlegal", {
          UserName: username
        });
        this.$gtag.event("users_saveacceptedlegal");
        return response.data;
      } catch (er) {
        return false;
      }
    },
    async acceptedLegal(username) {
      const access = await this.checkAccess();
      if (access && !access.IsServerlessAccountConfirmed) {
        this.$router.push({name: "verifyaccount", query: {username}});
      } else if (access && access.IsServerlessAccountConfirmed) {
        this.$router.push({name: "dashboard"});
      } else {
        //console.error(access);
      }
    },
    async confirmLegalPrompts(username) {
      const { value: acceptEula } = await Swal.fire({
        heightAuto: false,
        title: "End-User License Agreement",
        input: "checkbox",
        inputValue: 1,
        inputPlaceholder: `I agree with the <a href="https://omsmpc.einvoice.com.ph/eula.html" target="_blank" autofocus">EULA (End-User License Agreement)</a>`,
        confirmButtonText: `Continue&nbsp;<i class="fa fa-arrow-right"></i>`,
        inputValidator: (result) => {
          return !result && "You need to agree with EULA (End-User License Agreement)";
        }
      });
      if (acceptEula) {
        const { value: acceptTC } = await Swal.fire({
          heightAuto: false,
          title: "Terms and Conditions",
          input: "checkbox",
          inputValue: 1,
          inputPlaceholder: `I agree with the <a href="https://omsmpc.einvoice.com.ph/tc.html" target="_blank" autofocus>T&C (Terms and Conditions)</a>`,
          confirmButtonText: `Continue&nbsp;<i class="fa fa-arrow-right"></i>`,
          inputValidator: (result) => {
            return !result && "You need to agree with T&C (Terms and Conditions)";
          }
        });
        if (acceptTC) {
          const { value: acceptDisclaimer } = await Swal.fire({
            heightAuto: false,
            title: "Software/Data Disclaimer",
            input: "checkbox",
            inputValue: 1,
            inputPlaceholder: `I agree with the <a href="https://omsmpc.einvoice.com.ph/disclaimer.html" target="_blank" autofocus>DISCLAIMER (Software/Data Disclaimer)</a>`,
            confirmButtonText: `Continue&nbsp;<i class="fa fa-arrow-right"></i>`,
            inputValidator: (result) => {
              return !result && "You need to agree with Disclaimer (Software/Data Disclaimer)";
            }
          });
          if (acceptDisclaimer) {
            await this.saveAcceptedLegal(username);
            await this.acceptedLegal(username);
          }
        }
      }
    }
  },
  computed: {
    ...mapState({
      error: state => state.auth.errors,
      registermessage: state => state.auth.registermessage
    })
  },
  watch: {
    error() {
      this.isBusy = false;
    }
  }
};
</script>
